module.exports = __webpack_public_path__ + "fa32b9015efc9afb571e416dbda7126b.svg";